// Outcomes listed under the certificate section.
const certOutOutcomes = [
  "Critical thinking skills",
  "Practical approach toward design",
  "Professional skills",
  "Communication skills",
  "Broader industry perspective",
];

function CertificateOutcomeSection() {
  return (
    <section className="section certout-sec">
      <style>{`
        .certout-sec {
          background: var(--charcoal);
          color: var(--cream);
          position: relative;
          overflow: hidden;
          padding: 5rem 0;
        }
        .certout-sec .wrap {
          max-width: 1320px;
          margin: 0 auto;
          padding: 0 2.5rem;
        }
        @media (max-width: 700px) {
          .certout-sec {
            padding: 3rem 0;
          }
          .certout-sec .wrap {
            padding: 0 1.3rem;
          }
        }
        .certout-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3.5rem;
          align-items: center;
          position: relative;
          z-index: 2;
        }
        .certout-card {
          background: linear-gradient(160deg, #fffdf8, #f0ebe1);
          padding: 2.4rem;
          border: 1px solid var(--sand);
          box-shadow: 0 30px 60px -25px rgba(0, 0, 0, 0.7);
          position: relative;
        }
        .certout-card::after {
          content: "";
          position: absolute;
          inset: 0.7rem;
          border: 1px solid rgba(196, 154, 60, 0.45);
          pointer-events: none;
        }
        .certout-body {
          position: relative;
          text-align: center;
          color: var(--charcoal);
        }
        .certout-seal {
          margin: 0 auto 1rem;
        }
        .certout-k {
          font-family: var(--mono);
          font-size: 0.58rem;
          letter-spacing: 0.24em;
          text-transform: uppercase;
          color: var(--stone);
        }
        .certout-name {
          font-family: var(--serif);
          font-style: italic;
          font-size: 1.7rem;
          margin: 1rem 0 0.4rem;
          border-bottom: 1px solid var(--sand);
          display: inline-block;
          padding: 0 2rem 0.3rem;
        }
        .certout-prog {
          font-size: 0.85rem;
          font-weight: 500;
          margin-top: 0.7rem;
        }
        .certout-eyebrow {
          display: flex;
          align-items: center;
          gap: 0.7rem;
          margin-bottom: 1.1rem;
        }
        .certout-eyebrow-dash {
          width: 28px;
          height: 1px;
          background: var(--terra-lt);
        }
        .certout-eyebrow-text {
          font-family: var(--mono);
          font-size: 0.7rem;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: var(--terra-lt);
        }
        .certout-title {
          font-family: var(--serif);
          font-weight: 400;
          font-size: clamp(2rem, 3.4vw, 2.8rem);
          line-height: 1.15;
          color: var(--cream);
          margin: 0 0 1.2rem;
        }
        .certout-title em {
          font-style: italic;
          color: var(--terra-lt);
        }
        .certout-sub {
          font-size: 0.95rem;
          font-weight: 300;
          line-height: 1.8;
          color: var(--stone-lt, var(--stone));
          max-width: 46ch;
        }
        .certout-list {
          margin-top: 2rem;
          display: grid;
          gap: 1px;
          background: rgba(255, 255, 255, 0.12);
        }
        .certout-item {
          background: var(--charcoal);
          display: flex;
          align-items: center;
          gap: 0.9rem;
          padding: 0.9rem 0.2rem;
          font-size: 0.92rem;
        }
        .certout-item svg {
          width: 15px;
          height: 15px;
          stroke: var(--terra-lt);
          fill: none;
          stroke-width: 2;
          flex-shrink: 0;
        }
        .certout-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.55rem;
          background: var(--terra);
          color: #fff;
          font-size: 0.74rem;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          padding: 0.9rem 1.6rem;
          transition: background 0.25s, transform 0.25s;
        }
        .certout-btn:hover {
          background: var(--terra-lt);
          transform: translateY(-2px);
        }
        .certout-btn svg {
          width: 14px;
          height: 14px;
          stroke: currentColor;
          fill: none;
          stroke-width: 2;
          flex-shrink: 0;
        }
        .certout-note {
          font-family: var(--mono);
          font-size: 0.68rem;
          letter-spacing: 0.05em;
          color: var(--stone-lt, var(--stone));
        }
        @media (max-width: 900px) {
          .certout-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="bp dk" />
      <div className="wrap certout-grid">
        <div className="certout-card rv">
          <div className="certout-body">
            <svg
              className="certout-seal"
              width="52"
              height="52"
              viewBox="0 0 52 52"
              fill="none"
              stroke="#C49A3C"
              strokeWidth="1.2"
            >
              <circle cx="26" cy="26" r="24" />
              <circle cx="26" cy="26" r="19" strokeDasharray="3 3" />
              <path d="M15 32 L26 15 L37 32" stroke="#B85C28" strokeWidth="1.6" />
              <line x1="18" y1="34" x2="34" y2="34" stroke="#B85C28" />
            </svg>
            <div className="certout-k">Institute of Planners and Designers India</div>
            <div style={{ fontFamily: "var(--serif)", fontSize: "1.1rem", marginTop: "0.6rem" }}>
              Certificate of Completion
            </div>
            <div className="certout-name">Your Name</div>
            <div className="certout-prog">Executive Architect Certification Program</div>
            <div className="certout-k" style={{ marginTop: "1.4rem" }}>
              Ref. IPDI/EA/2025 · Verified
            </div>
          </div>
        </div>

        <div className="rv d2">
          <div className="certout-eyebrow">
            <div className="certout-eyebrow-dash" />
            <span className="certout-eyebrow-text">Recognition &amp; Outcome</span>
          </div>
          <h2 className="certout-title">
            A certificate that <em>carries weight</em>
          </h2>
          <p className="certout-sub">
            Recognised by partner firms across India's architecture and design
            industry — and backed by a portfolio of real drawings you can put
            on the table in an interview. Here's what you walk out with.
          </p>
          <div className="certout-list">
            {certOutOutcomes.map((outcome) => (
              <div className="certout-item" key={outcome}>
                <svg viewBox="0 0 24 24">
                  <path d="M4 12l6 6L20 6" />
                </svg>
                {outcome}
              </div>
            ))}
          </div>
          {/* <div style={{ marginTop: "2rem", display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}>
            <a href="#admissions" className="certout-btn">
              Download Brochure
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 4v12M6 12l6 6 6-6M4 21h16" />
              </svg>
            </a>
            <span className="certout-note">
              Want the full picture before you commit?
            </span>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default CertificateOutcomeSection;